import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';

interface HeaderProps {
  currentPage: 'analysis' | 'documentation' | 'support';
  onPageChange: (page: 'analysis' | 'documentation' | 'support') => void;
}

const Header: React.FC<HeaderProps> = ({ currentPage, onPageChange }) => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-600 p-2 rounded-lg">
              <ChartBarIcon className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-800">Paries Excel</h1>
              <p className="text-sm text-gray-600">Analyseur Financier</p>
            </div>
          </div>
          
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => onPageChange('analysis')}
              className={`transition-colors ${
                currentPage === 'analysis' 
                  ? 'text-blue-600 font-medium' 
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Analyse
            </button>
            <button 
              onClick={() => onPageChange('documentation')}
              className={`transition-colors ${
                currentPage === 'documentation' 
                  ? 'text-blue-600 font-medium' 
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Documentation
            </button>
            <button 
              onClick={() => onPageChange('support')}
              className={`transition-colors ${
                currentPage === 'support' 
                  ? 'text-blue-600 font-medium' 
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              Support
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header; 